import { __awaiter, __extends, __generator, __read, __spreadArray } from "tslib";
import { AsyncOptional, PresentAsyncOptional } from "./AsyncOptional";
var OptionalValueMissingError = (function (_super) {
    __extends(OptionalValueMissingError, _super);
    function OptionalValueMissingError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OptionalValueMissingError;
}(Error));
export { OptionalValueMissingError };
var Optional = (function () {
    function Optional() {
    }
    Optional.prototype.instanceOf = function () {
        var klasses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            klasses[_i] = arguments[_i];
        }
        return this.filter(function (value) { return !!klasses.find(function (klass) { return value instanceof klass; }); });
    };
    Optional.prototype.tap = function (view) {
        return this.map(function (value) {
            view(value);
            return value;
        });
    };
    Optional.prototype.tapAsync = function (view) {
        var _this = this;
        return this.mapAsync(function (value) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, view(value)];
                    case 1:
                        _a.sent();
                        return [2, value];
                }
            });
        }); });
    };
    Optional.prototype.pick = function (key) {
        return this.map(function (value) { return value[key]; });
    };
    Optional.prototype.call = function (key) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return this.map(function (value) {
            var _a;
            return (_a = value)[key].apply(_a, __spreadArray([], __read(args), false));
        });
    };
    Optional.prototype.callAsync = function (key) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return this.mapAsync(function (value) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                return [2, (_a = value)[key].apply(_a, __spreadArray([], __read(args), false))];
            });
        }); });
    };
    Optional.prototype.defaultTo = function (value) {
        return this.isAbsent() ? Optional.of(value) : this;
    };
    Optional.prototype.defaultGet = function (method) {
        return this.isAbsent() ? Optional.of(method()) : this;
    };
    Optional.prototype.defaultGetFlat = function (method) {
        return this.isAbsent() ? method() : this;
    };
    Optional.prototype.defaultGetAsync = function (method) {
        var _this = this;
        return this.isAbsent()
            ? AsyncOptional.of(method())
            : this.mapAsync(function (i) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2, i];
            }); }); });
    };
    Optional.prototype.defaultGetFlatAsync = function (method) {
        var _this = this;
        return this.isAbsent() ? method() : this.mapAsync(function (i) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2, i];
        }); }); });
    };
    Optional.of = function (value) {
        if (value instanceof Optional)
            return value;
        return value == null
            ? new AbsentOptional()
            : new PresentOptional(value);
    };
    Optional.fromJSON = function (data) { return Optional.of(data); };
    Optional.empty = function () {
        return new AbsentOptional();
    };
    return Optional;
}());
export { Optional };
var PresentOptional = (function (_super) {
    __extends(PresentOptional, _super);
    function PresentOptional(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PresentOptional.prototype.toArray = function () {
        return [this.value];
    };
    PresentOptional.prototype.unzip = function () {
        var _a = __read(this.get(), 2), a = _a[0], b = _a[1];
        return [Optional.of(a), Optional.of(b)];
    };
    PresentOptional.prototype.unzip3 = function () {
        var _a = __read(this.get(), 3), a = _a[0], b = _a[1], c = _a[2];
        return [Optional.of(a), Optional.of(b), Optional.of(c)];
    };
    PresentOptional.prototype.zip = function () {
        var others = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            others[_i] = arguments[_i];
        }
        var result = [this.value];
        for (var i = 0; i < others.length; i++) {
            if (others[i].isPresent()) {
                result.push(others[i].get());
            }
            else {
                return Optional.empty();
            }
        }
        return Optional.of(result);
    };
    PresentOptional.prototype.filter = function (predicate) {
        return predicate(this.value)
            ? new PresentOptional(this.value)
            : new AbsentOptional();
    };
    PresentOptional.prototype.filterNot = function (predicate) {
        return this.filter(function (v) { return !predicate(v); });
    };
    PresentOptional.prototype.map = function (transform) {
        return Optional.of(transform(this.value));
    };
    PresentOptional.prototype.mapAsync = function (transform) {
        return PresentAsyncOptional.fromPromise(transform(this.value));
    };
    PresentOptional.prototype.flatMap = function (transform) {
        return transform(this.value);
    };
    PresentOptional.prototype.flatMapAsync = function (transform) {
        return PresentAsyncOptional.fromPromise(transform(this.value).then(function (v) { return v.orElse(null); }));
    };
    PresentOptional.prototype.orElse = function (_) {
        return this.value;
    };
    PresentOptional.prototype.orGet = function () {
        return this.value;
    };
    PresentOptional.prototype.orThrow = function () {
        return this.value;
    };
    PresentOptional.prototype.toJSON = function () {
        return this.value;
    };
    PresentOptional.prototype.asJSON = function () {
        return this.value;
    };
    PresentOptional.prototype.isPresent = function () {
        return true;
    };
    PresentOptional.prototype.isAbsent = function () {
        return false;
    };
    PresentOptional.prototype.get = function () {
        return this.value;
    };
    return PresentOptional;
}(Optional));
export { PresentOptional };
var AbsentOptional = (function (_super) {
    __extends(AbsentOptional, _super);
    function AbsentOptional() {
        return _super.call(this) || this;
    }
    AbsentOptional.prototype.toArray = function () {
        return [];
    };
    AbsentOptional.prototype.unzip = function () {
        return [Optional.empty(), Optional.empty()];
    };
    AbsentOptional.prototype.unzip3 = function () {
        return [Optional.empty(), Optional.empty(), Optional.empty()];
    };
    AbsentOptional.prototype.zip = function () {
        return new AbsentOptional();
    };
    AbsentOptional.prototype.map = function () {
        return new AbsentOptional();
    };
    AbsentOptional.prototype.mapAsync = function () {
        return AsyncOptional.empty();
    };
    AbsentOptional.prototype.filter = function () {
        return new AbsentOptional();
    };
    AbsentOptional.prototype.filterNot = function () {
        return new AbsentOptional();
    };
    AbsentOptional.prototype.flatMap = function () {
        return new AbsentOptional();
    };
    AbsentOptional.prototype.flatMapAsync = function () {
        return AsyncOptional.empty();
    };
    AbsentOptional.prototype.orElse = function (other) {
        return other;
    };
    AbsentOptional.prototype.orGet = function (supplier) {
        return supplier();
    };
    AbsentOptional.prototype.orThrow = function (errThrower) {
        var err = errThrower();
        if (err instanceof Error) {
            throw err;
        }
        else {
            throw TypeError("Optional.orThrow callback did not throw or return an error");
        }
    };
    AbsentOptional.prototype.toJSON = function () {
        return null;
    };
    AbsentOptional.prototype.asJSON = function () {
        return null;
    };
    AbsentOptional.prototype.isPresent = function () {
        return false;
    };
    AbsentOptional.prototype.isAbsent = function () {
        return true;
    };
    AbsentOptional.prototype.get = function () {
        throw new OptionalValueMissingError(".get() was called on an optional that had no value. Add a check before unwrapping.");
    };
    return AbsentOptional;
}(Optional));
export { AbsentOptional };
